import { useAudienceExplorerSearchStore } from "@/stores/AudienceExplorerSearchStore";
import { useMetaAudienceStore } from "@/stores/MetaAudienceStore";
import { useAppStateStore } from "@/stores/AppStateStore";
import { logPageVisit } from "@/helpers/userEvents";

export const logAudienceExplorerPageVisit = (to, from) => {
  const audienceExplorerSearchStore = useAudienceExplorerSearchStore();
  logPageVisit(to, from, {
    meta_audience: audienceExplorerSearchStore.metaAudience?.name,
    geography: audienceExplorerSearchStore.prettifyGeo,
  });
};

const loadAudienceExplorerData = async (to, from) => {
  const metaAudienceStore = useMetaAudienceStore();
  const audienceExplorerSearchStore = useAudienceExplorerSearchStore();

  audienceExplorerSearchStore.error = undefined;

  await metaAudienceStore.getPremiumAudiences();
  await audienceExplorerSearchStore.loadMetaAudience(
    to.params.meta_audience_id,
  );
  await audienceExplorerSearchStore.loadGeography(to.params.geography_id);
  await audienceExplorerSearchStore.loadPartnerCuts();
  audienceExplorerSearchStore.initializing = false;

  audienceExplorerSearchStore.getSampleRatio();
  await audienceExplorerSearchStore.getAudienceCounts();
  audienceExplorerSearchStore.getDemographics();
  audienceExplorerSearchStore.getCategoryInsights("Consumer");
  audienceExplorerSearchStore.getCategoryInsights("Advocacy");
  audienceExplorerSearchStore.getMarketRanker();
  audienceExplorerSearchStore.checkHouseholdThreshold();
  audienceExplorerSearchStore.getLinearStreaming();
  audienceExplorerSearchStore.getMediaMix();
  audienceExplorerSearchStore.getBehavioralInsights();
  audienceExplorerSearchStore.getHaloInsights();
  logAudienceExplorerPageVisit(to, from);
};

export const initAudienceExplorer = async (to, from) => {
  const audienceExplorerSearchStore = useAudienceExplorerSearchStore();
  if (to.params.meta_audience_id && to.params.geography_id) {
    audienceExplorerSearchStore.initializing = true;
    // Allow navigation immediately, then continue loading in the background
    // (preserves the previous next()-then-continue behavior).
    void loadAudienceExplorerData(to, from);
    return;
  }

  const appStateStore = useAppStateStore();
  audienceExplorerSearchStore.error = undefined;
  await audienceExplorerSearchStore.loadDefaultAudience();
  const metaAudienceId =
    audienceExplorerSearchStore.metaAudience?.id ||
    audienceExplorerSearchStore.defaultMetaAudienceId;
  if (!metaAudienceId) {
    // Auth failures are handled by the router guard and API middleware.
    // A null id after a non-401 response is a load failure, not session expiry.
    appStateStore.breadcrumbs = [];
    return;
  }
  appStateStore.breadcrumbs = [];
  return {
    name: to.name,
    params: {
      meta_audience_id: metaAudienceId,
      geography_id: audienceExplorerSearchStore.geography?.id || 1,
    },
  };
};
